export default __webpack_public_path__ + "static/clutch_2022-7b5aff120f54d8bcac5c96d8a804a934.png";